import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'newLine', standalone: true })
export class NewLine implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value.replace(/\r?\n/g, '<br>');
  }
}
